import { render } from "./FormChangePassword.vue?vue&type=template&id=bf1e95d8"
import script from "./FormChangePassword.vue?vue&type=script&lang=js"
export * from "./FormChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__